export default __webpack_public_path__ + "static/media/withdraw.fbc98fc8.svg";